module.exports = __webpack_public_path__ + "static/media/funding-landscape.8f05a341.svg";